import React, { useState } from 'react';
import { LayoutGridIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useMixedShelf } from './useMixedShelf';
import { SearchFilters } from './SearchFilters';
import { MixedGrid, CoverCarousel, SpineView, MixedInfoModal } from './ItemDisplay';
const MixedShelf = () => {
  const {
    category,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    viewMode,
    setViewMode,
    sortOption,
    setSortOption,
    darkMode,
    hoveredItemId,
    setHoveredItemId,
    mousePosition,
    booksPerShelf,
    shelfContainerRef,
    sortedItems,
    bookItems,
    navigateToCategory,
    navigateToEdit,
    navigate
  } = useMixedShelf();
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const showViewToggle = category === 'books' || !category;
  const tabs = [{
    label: 'All',
    key: undefined
  }, {
    label: 'Books & Special Editions',
    key: 'books'
  }, {
    label: 'Merch',
    key: 'merch'
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-20109" data-mp="33rkhikq5h1b0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20110" data-mp="3ck4jnv5nho0l">
        <div className="mb-6" data-id="element-20111" data-mp="3cko1lbvawcem">
          <div className="mb-3" data-id="element-20112" data-mp="3cmh1877hxwd4">
            <BackButton data-id="element-20113" data-mp="2ots3xy45ymzg" />
          </div>
          <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-20114" data-mp="2outpwxmpwtvy">
            My Catalog
          </h1>
          <p className={`mt-1 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-20115" data-mp="2yszrtf8iy00t">
            All your books and merchandise in one place
          </p>
        </div>

        <div className={`mb-6 flex space-x-1 overflow-x-auto border-b ${darkMode ? 'border-gray-700' : 'border-gray-300'}`} data-id="element-20116" data-mp="e1z78wutewed">
          {tabs.map(tab => <button key={tab.label} onClick={() => tab.key ? navigateToCategory(tab.key) : navigate('/vendor/shelf')} className={`py-2 px-4 font-medium whitespace-nowrap ${category === tab.key ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-20117" data-mp="h43r76zvt4lt">
              {tab.label}
            </button>)}
        </div>

        <SearchFilters searchTerm={searchTerm} setSearchTerm={setSearchTerm} showFilters={showFilters} setShowFilters={setShowFilters} viewMode={viewMode} setViewMode={setViewMode} sortOption={sortOption} setSortOption={setSortOption} darkMode={darkMode} showViewToggle={showViewToggle} data-id="element-20118" data-mp="2d4lq4ucew6g" />

        <div ref={shelfContainerRef} data-id="element-20119" data-mp="3fs0x5baxwxhr">
          {/* All tab or Merch tab — grid view */}
          {(!category || category === 'merch') && viewMode === 'cover' && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-20120" data-mp="33cjaybbplhop">
              {sortedItems.length > 0 ? <MixedGrid items={sortedItems} darkMode={darkMode} onItemClick={item => setSelectedItem(item)} onHoverEnter={id => !isMobile && setHoveredItemId(id)} onHoverLeave={() => setHoveredItemId(null)} data-id="element-20121" data-mp="2tdtvsqb76bc5" /> : <div className="text-center py-12" data-id="element-20122" data-mp="2fmfdklp46e65">
                  <LayoutGridIcon className={`h-12 w-12 ${darkMode ? 'text-gray-600' : 'text-gray-400'} mx-auto mb-4`} data-id="element-20123" data-mp="2ancfjl7jx87o" />
                  <p className={darkMode ? 'text-gray-400' : 'text-gray-500'} data-id="element-20124" data-mp="25pu3vn25gevz">
                    No items found
                  </p>
                </div>}
            </div>}

          {/* Books tab — spine or cover */}
          {category === 'books' && (viewMode === 'spine' ? <SpineView items={bookItems} darkMode={darkMode} booksPerShelf={booksPerShelf} hoveredBookId={hoveredItemId} setHoveredBookId={setHoveredItemId} mousePosition={mousePosition} onBookClick={book => setSelectedItem(book)} data-id="element-20125" data-mp="2hkglz1uuvco6" /> : <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-20126" data-mp="2cjavlaoo41ht">
                <MixedGrid items={sortedItems} darkMode={darkMode} onItemClick={item => setSelectedItem(item)} onHoverEnter={id => !isMobile && setHoveredItemId(id)} onHoverLeave={() => setHoveredItemId(null)} data-id="element-20127" data-mp="22mo9kiklv4e7" />
              </div>)}

          {/* All tab spine view — books only on shelf, merch in grid below */}
          {!category && viewMode === 'spine' && <>
              <SpineView items={bookItems} darkMode={darkMode} booksPerShelf={booksPerShelf} hoveredBookId={hoveredItemId} setHoveredBookId={setHoveredItemId} mousePosition={mousePosition} onBookClick={book => setSelectedItem(book)} data-id="element-20128" data-mp="1v3yi461r1u36" />
              {sortedItems.filter(i => i.itemType === 'merch').length > 0 && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-20129" data-mp="2e1rjv50mzxyz">
                  <h2 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-20130" data-mp="jo02tkfzabti">
                    Merchandise
                  </h2>
                  <MixedGrid items={sortedItems.filter(i => i.itemType === 'merch')} darkMode={darkMode} onItemClick={item => setSelectedItem(item)} onHoverEnter={id => !isMobile && setHoveredItemId(id)} onHoverLeave={() => setHoveredItemId(null)} data-id="element-20131" data-mp="2es7uipdbaj21" />
                </div>}
            </>}
        </div>
      </div>

      {selectedItem && <MixedInfoModal item={selectedItem} darkMode={darkMode} onClose={() => setSelectedItem(null)} onEdit={id => navigateToEdit(id, selectedItem.itemType)} data-id="element-20132" data-mp="32pdkodipy22j" />}
    </div>;
};
export default MixedShelf;